import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { intlShape } from '../../components/prop-types';
import LogoUploadDropZone from './LogoUploadDropZone';
import { APP_BASENAME } from '../../config';

const messages = defineMessages({
  upload: { id: 'uploadlogo.lbl', defaultMessage: 'Upload Logo' },
  currentLogo: { id: 'currentLogo.msg', defaultMessage: 'Current logo for this account' },
  noLogo: { id: 'nologo.msg', defaultMessage: 'No logo available for this account' },
});

const UploadLogo = (props) => {
  const {
    onUpload,
    intl: { formatMessage },
    data,
  } = props;

  return (
    <div className="p-grid">
      <div className="p-col-12">
        {
          data.account.brandingInformation.logo.url
            ? (
              <div>
                <br />
                <img
                  src={data.account.brandingInformation.logo.url}
                  alt={formatMessage(messages.currentLogo)}
                  title={formatMessage(messages.currentLogo)}
                  style={{
                    width: '128px',
                    height: 'auto',
                    marginTop: '5px',
                    border: '1px solid lightgray',
                  }}
                />
              </div>
            )
            : (
              <div>
                <br />
                <img
                  src={`${APP_BASENAME}/images/default-logo.png`}
                  alt={formatMessage(messages.noLogo)}
                  title={formatMessage(messages.noLogo)}
                />
              </div>
            )
        }
      </div>
      <div className="p-col-12">
        <LogoUploadDropZone onUpload={onUpload} />
      </div>
    </div>
  );
};

UploadLogo.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  onUpload: PropTypes.func.isRequired,
};

export default injectIntl(UploadLogo);
